'use strict';

require('prop-types');
var React = require('react');
var PageHeaderMobile = require('./Mobile/PageHeaderMobile.js');
var PageHeader = require('./PageHeader.js');
var Hidden = require('../../node_modules/@material-ui/core/esm/Hidden/Hidden.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var OptionInvoiceHeader = function OptionInvoiceHeader(props) {
  var option = props.option,
      customer = props.customer,
      address = props.address,
      organization = props.organization,
      pro = props.pro,
      settings = props.settings,
      preparedDate = props.preparedDate,
      isPresenting = props.isPresenting;
  var option_number = option.option_number,
      name = option.name;
  var display_name = customer.display_name;
  var printable_address = address.printable_address;
  var logo_url = organization.logo_url;
  var full_name = pro.full_name;
  return React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(Hidden, {
    xsDown: true
  }, React__default["default"].createElement(PageHeader, {
    title: name,
    customerName: display_name,
    address: printable_address,
    preparer: full_name,
    number: option_number,
    date: preparedDate,
    logoUrl: logo_url,
    settings: settings,
    isPresenting: isPresenting
  })), React__default["default"].createElement(Hidden, {
    smUp: true
  }, React__default["default"].createElement(PageHeaderMobile, {
    title: name,
    customerName: display_name,
    address: printable_address,
    preparer: full_name,
    number: option_number,
    date: preparedDate,
    logoUrl: logo_url,
    settings: settings,
    isPresenting: isPresenting
  })));
};

module.exports = OptionInvoiceHeader;
